import React from 'react';
import ReactDOM from 'react-dom/client'; // For React 18+
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
 
// Create a root and render the app
const root = ReactDOM.createRoot(document.getElementById('root')); // Create root element
root.render(
<BrowserRouter>
<App />
</BrowserRouter>
);